import VueChartJs from 'vue-chartjs'

export default {
  extends: VueChartJs.Line,
  props: ['chartData', 'color1', 'color2', 'chartLabels', 'title', 'drawYGrids'],
  mounted () {
    this.addPlugin({
      id: 'y-axis-plugin',
      afterLayout: chart => {
        let ctx = chart.ctx
        ctx.save()

        var gradient = chart.ctx.createLinearGradient(
          0 /* left */, chart.scales['y-axis-0'].bottom,
          0 /* right */, chart.scales['y-axis-0'].top
        )
        // add gradients stops
        gradient.addColorStop(0, this.color1)
        gradient.addColorStop(1, this.color2)

        chart.data.datasets[0].backgroundColor = gradient
        chart.data.datasets[0].borderColor = gradient
        chart.data.datasets[0].pointBorderColor = gradient
        chart.data.datasets[0].pointBackgroundColor = gradient
        chart.data.datasets[0].pointHoverBackgroundColor = gradient
        chart.data.datasets[0].pointHoverBorderColor = gradient
        ctx.restore()
      }
    })
    this.render()
  },
  watch: {
    'chartData' (to, from) {
      this.render()
    },
    'color1' (to, from) {
      this.render()
    },
    'color2' (to, from) {
      this.render()
    },
    'title' (to, from) {
      this.render()
    },
    'chartLabels' (to, from) {
      this.render()
    }
  },
  methods: {
    render () {
      if (!this.chartData) {
        return
      }

      var data = {
        label: this.title,
        borderColor: '#f87979',
        fill: false,
        data: this.chartData
      }

      this.renderChart({
        labels: this.chartLabels,
        datasets: [
          data
        ]
      }, {
        /* animation: {
          duration: 1,
          onComplete: function() {
            var controller = this.chart.controller;
            var chart = controller.chart;
            var ctx = chart.ctx;
            var xAxis = controller.scales['x-axis-0'];
            var tickGap = xAxis.getPixelForTick(1) - xAxis.getPixelForTick(0);

            xAxis.ticks.forEach(function(value, index) {
              var yPos = xAxis.top;
              var xPos = xAxis.getPixelForTick(index);
              var xOffset = xPos + (tickGap * 3 / 2) / 2;
              ctx.fillText(value, xOffset, yPos);
            });

          }
        }, */
        /* animation: {
          duration: 1,
          onComplete: function () {
            var controller = this.chart.controller;
            var chart = controller.chart;
            var ctx = chart.ctx;
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";
            console.log(chart)
            console.log(chart.data.datasets[0])
            chart.data.datasets.forEach(function (dataset) {
                dataset.points.forEach(function (points) {
                    ctx.fillText(points.value, points.x, points.y - 10);
                });
            })
          }
        }, */
        spanGaps: true,
        animation: false,
        aspectRatio: 2,
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          enabled: true,
          titleFontSize: 22,
          bodyFontSize: 25
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              steps: 10,
              stepValue: 5,
              min: 0,
              max: Math.max(...this.chartData) + 10,
              display: false
            },
            gridLines: {
              drawOnChartArea: false
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 20
            },
            gridLines: {
              drawBorder: false,
              beginAtZero: true,
              offset: true,
              display: this.drawYGrids !== undefined ? this.drawYGrids : true
            }
          }]
        },
        elements: {
          point: {
            radius: 3
          }
        }
      })
    },
    export2image: function () {
      let image = document.getElementById(this.$attrs.id).querySelector('canvas').toDataURL('image/png')
      return image
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LineChart.js